declare var $;
declare var Cookies;
declare var globalSns

export function ajaxGet(route, callback) {
    
    $.ajax({
        type: "GET",
        url: globalSns.webApiUrl + route,
        headers: { "Authorization": "Bearer " + Cookies.get("namezzz")},
        success: function(data) {
            callback(data, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                var suffixApplicant = "useractions";
                var suffixExtranet = "extranetactions";
                if (route.indexOf(suffixApplicant, route.length - suffixApplicant.length) === -1 && 
                    route.indexOf(suffixExtranet, route.length - suffixExtranet.length) === -1) {
                        handleUnauthorized();
                        return;
                }
            }
            callback(jqXHR, false);
        }
    });
}

export function ajaxPost(route, data, callback) {
    $.ajax({
        type: "POST",
        url: globalSns.webApiUrl + route,
        headers: { "Authorization": "Bearer " + Cookies.get("namezzz")},
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function(newData) {
            callback(newData, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                handleUnauthorized();
            } else {
                callback(jqXHR, false);
            }
        }
    });    
}

export function ajaxDelete(route, callback) {
    $.ajax({
        type: "DELETE",
        url: globalSns.webApiUrl + route,
        headers: { "Authorization": "Bearer " + Cookies.get("namezzz")},
        contentType: "application/json",
        success: function(newData) {
            callback(newData, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                handleUnauthorized();
            } else {
                callback(jqXHR, false);
            }
        }
    })    
}

export function ajaxPostBytes(route, data, callback) {
    $.ajax({
        type: "POST",
        url: globalSns.webApiUrl + route,
        headers: { "Authorization": "Bearer " + Cookies.get("namezzz")},
        contentType: false,
        cache: false,
        processData: false,
        data: data,
        success: function(newData) {
            callback(newData, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                handleUnauthorized();
            } else {
                callback(jqXHR, false);
            }
        }
    })
}

export function ajaxGetAnon(route, callback) {
    $.ajax({
        type: "GET",
        url: globalSns.webApiUrl + route,
        success: function(data) {
            callback(data, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                handleUnauthorized();
            } else {
                callback(jqXHR, false);
            }
        }
    });
}

export function ajaxPostAnon(route, data, callback) {
    $.ajax({
        type: "POST",
        url: globalSns.webApiUrl + route,
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function(newData) {
            callback(newData, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                handleUnauthorized();
            } else {
                callback(jqXHR, false);
            }
        }
    });    
}

export function ajaxPostFormAnon(route, data, callback) {
    $.ajax({
        type: "POST",
        url: globalSns.webApiUrl + route,
        contentType: "application/x-www-form-urlencoded",
        data: data,
        success: function(newData) {
            callback(newData, true);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 401) {
                handleUnauthorized();
            } else {
                callback(jqXHR, false);
            }
        }
    });    
}

export function handleUnauthorized() {
    window.location = globalSns.sessionLostUrl;
}


// WEBPACK FOOTER //
// ./src/Api/AjaxHelper.js